import { action } from 'satcheljs';
import type { ActionMessage } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OnBriefingEventUpdateSentActionMessage extends ActionMessage {
    itemId: string;
    mailboxInfo: MailboxInfo;
}

/**
 * Fired when the user sends a proposed agenda to a meeting's attendees. The
 * PersonalOS store listens and marks the originating item done via
 * `PATCH /pos/briefing/actions {op:'done'}`. `itemId` is the D2
 * briefing-projection id.
 *
 * Only a confirmed write fires this. A no-op write (the invite already carried
 * the agenda) is the outcome the user asked for and completes the item too; a
 * failed write must not, or the card would disappear over an unchanged meeting.
 */
export const onBriefingEventUpdateSent: (
    itemId: string,
    mailboxInfo: MailboxInfo
) => OnBriefingEventUpdateSentActionMessage = action(
    'onBriefingEventUpdateSent',
    (itemId: string, mailboxInfo: MailboxInfo) => ({
        itemId,
        mailboxInfo,
    })
);
